<template>
  <div class="message-create-control" :class="{'message-create-control-open': open}">
    <primary-button v-if="!open" :label="i18n.t('member.forums.new_post')" @click="startPost" />
    <div v-else id="new-thread" class="mb20">
      <profile-image class="me-3" :user="currentUser" size="lg" />
      <form class="create-post-form d-grid gap-3">
        <text-input input-id="title" :label="i18n.t('member.forums.thread_title')" :value="title"
                    :validation-errors="validationErrors.forumThread"
                    @changed="(value) => setField('title', value)" />
        <text-input input-id="body" :label="i18n.t('member.forums.body')" :value="content" multiline
                    :validation-errors="validationErrors.forumMessage"
                    @changed="(value) => setField('content', value)" />
        <div>
          <submit-button :form-valid="!!title && !!content" :label="i18n.t('member.forums.post')"
                         :submit-in-progress="submitInProgress" @click="createPost" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ProfileImage from '../components/members/profile-image'
import PrimaryButton from '../components/buttons/primary-button'
import SubmitButton from '../components/buttons/submit-button'
import TextInput from '../components/inputs/text-input'
import { mapState } from 'vuex'

export default {
  components: { PrimaryButton, ProfileImage, SubmitButton, TextInput },
  props: {
    createPath: {
      type: String,
      required: true
    }
  },

  emits: ['created-thread'],

  data() {
    return {
      open: false,
      title: '',
      content: '',
      validationErrors: {},
      submitInProgress: false
    }
  },

  computed: {
    ...mapState(['currentUser'])
  },
  methods: {
    createPost() {
      this.submitInProgress = true

      this.$store.dispatch('createThread', {
        url: this.createPath, title: this.title, messageAttributes: {content: this.content}
      }).then(() => {
        this.$emit('created-thread')
        this.resetPost()
      }).catch((e) => {
        this.validationErrors = e.info.validationErrors
      }).finally(() => {
        this.submitInProgress = false
      })
    },

    startPost() {
      this.open = true
    },
    setField(field, value) {
      this[field] = value
    },
    resetPost() {
      this.title = ''
      this.content = ''
      this.validationErrors = {}
      this.open = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .message-create-control-open {
    flex-basis: 100%;
  }

  #new-thread {
    display: flex;
    align-items: flex-start;
  }

  .create-post-form {
    flex: 1;
  }
</style>
